import React from "react";
import { PuffLoader } from "react-spinners";

const Loader = ({ local, custom, className, color, size }) => {
  const style = {
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: "1000",
  };

  if (local) {
    return (
      <div className="justify-content-between text-center">
        <PuffLoader color="#be97e8" size={size} />
      </div>
    );
  } else if (custom) {
    return (
      <div className={className}>
        <PuffLoader
          color={color !== undefined ? color : "#be97e8"}
          size={size}
        />
      </div>
    );
  } else {
    return (
      <div style={style}>
        <PuffLoader color="#be97e8" size={100} />
      </div>
    );
  }
};

export default Loader;
